import React from "react"
import type { StyleProps } from "@mallardbay/lib-react-components"
import { Image } from "@chakra-ui/react"
import { componentStyles } from "@mallardbay/lib-react-components"

import type { PropsWithChildrenAndStyle } from "~components/shared/todo-lib-react-components/types"
import AspectRatio from "~components/shared/todo-lib-react-components/aspect-ratio"

interface Props extends PropsWithChildrenAndStyle {
    readonly style?: StyleProps
    readonly ratio: number
    readonly src?: string
    readonly alt?: string
    readonly imageStyle?: StyleProps
}

export default function AspectRatioImage({
    style,
    imageStyle,
    ratio,
    src,
    alt,
}: Props) {
    const styles = useStyles()

    return (
        <AspectRatio style={style} ratio={ratio}>
            <Image
                sx={{ ...styles.image, ...imageStyle }}
                src={src}
                alt={alt}
            />
        </AspectRatio>
    )
}

function useStyles() {
    return componentStyles({
        image: {
            objectFit: "cover",
            borderRadius: "xl",
        },
    })
}
